/*
 * Public API Surface of knowledge-base-lib
 */

export * from './lib/knowledge-base-lib.service';
export * from './lib/knowledge-base-lib.component';
export * from './lib/knowledge-base-lib.module';
export * from './lib/modal-base-conocimiento/modal-base-conocimiento.component';
